import { useEffect, useState } from "react";
import { useToast } from "../../toastHook";
import axios from 'axios';
import { comparer } from "../../utils/comparer";
import moment from 'moment';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

export const LoadIntercontratsComponent = () => {

    const [uploading, setUploading] = useState(false);
    const { display } = useToast();
    const [intercontratsLoad, setIntercontratsLoad] = useState([]);
    const [count, setCount] = useState(0);

    useEffect(() => {

        axios.get('/api/importintercontrat/historic')
            .then(response => {

                if (response.data) {

                    response.data.sort( (x, y) => - comparer(x.date, y.date));
                    setIntercontratsLoad(response.data)
                }

            });

    }, [count]);

    const submitLoad = event => {

        setUploading(true);

        event.preventDefault();

        const formData = new FormData();
        formData.append("file", event.target.loadFile.files[0]);

        axios.post('/api/importintercontrat/load', formData)
            .then(response => {

                if (response.status === 200 && response.data.isSuccess) {
                    display({
                        titre: 'intercontrats chargés',
                        text: `le fichier d'intercontrat a correctement été chargé'`,
                        severity: 'success'
                    });
                }
                else {
                    display({
                        titre: 'non chargé',
                        text: `le fichier d'intercontrat n'a pas été chargé, raison: ${ response.data?.errorMessage }'`,
                        severity: 'danger'
                    });
                }

                event.target.reset();


                setUploading(false);
            })
            .catch(() => { setUploading(false); });

    }

    const formatDate = row => {
        return <>{moment(row.date).format('lll')}</>
    }

    const isValidIcon = row => {
        if (row.isSuccess) {
            return <i className="pi pi-chevron-down text-success"  ></i>
        }

        if (!row.isFinished) {
            return <i className="bi bi-arrow-repeat text-primary"  ></i>
        }

        return <i className="pi pi-minus-circle text-danger" ></i>
    }

    const reload = () => setCount(count + 1);

    return <div>
        <h3>Chargement des intercontrats</h3>
        <div className="alert alert-info">
            Veuillez charger un fichier csv d'intercontrat issue de sales force<br />
            <form onSubmit={ submitLoad } className="mt-3">
                <div className="d-flex flex-row gap-3">
                <input className="flex-grow-1" type="file" className="form-control" id="loadFile" name="loadFile" required />
                    <button type="submit" className="btn btn-success" disabled={ uploading } >Charger</button>
                </div>
            </form><br />
            <button className="btn btn-outline-primary" onClick={ reload }>Recharger</button>
        </div>
        <DataTable value={intercontratsLoad} tableStyle={{ width: '100%' }}>
            <Column field="date" header="Date"  body={formatDate} />
            <Column field="errorMessage" header="Message d'erreur"  />
            <Column header="Status" body={isValidIcon} />
        </DataTable>
    </div>
}





